/**
 * Resume Studio — shared constants.
 *
 * Kept here so both ResumeStudioPage.jsx and the extracted flow/preview
 * components can import them without a circular dependency.
 */

export const TIER_META = {
    fresher: {
        label: "Fresher Starter",
        badge: "First CV",
        subtitle: "Perfect for students & first-time job seekers",
        color: "from-emerald-500 to-teal-600",
        revisions_label: "1 free AI revision",
        highlights: ["1 ATS template", "1 free AI revision", "24-hr delivery"],
    },
    standard: {
        label: "Standard",
        badge: "Popular",
        subtitle: "For experienced professionals wanting a clean ATS rewrite",
        color: "from-cobalt-500 to-blue-600",
        revisions_label: "Final output only (no revisions)",
        highlights: ["3 ATS templates", "AI rewrite", "PDF download"],
    },
    pro: {
        label: "Pro",
        badge: "Best value",
        subtitle: "3 AI revisions + graphic templates",
        color: "from-purple-500 to-fuchsia-600",
        revisions_label: "3 AI revisions",
        highlights: ["6 templates (ATS + Pro)", "3 AI revisions", "Priority processing"],
    },
    elite: {
        label: "Elite",
        badge: "Executive",
        subtitle: "10 AI revisions + full infographic set",
        color: "from-amber-500 to-orange-600",
        revisions_label: "10 AI revisions",
        highlights: ["9 templates (Elite infographic)", "10 AI revisions", "Human polish add-on"],
    },
};
